import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useScrollLock } from "../../hooks/useScrollLock";

import {
  ModalOverlay,
  ModalContainer,
  CloseButton,
  ModalContent,
  Row,
  ModalTitle,
  ModalText,
  ModalTextBlue,
} from "./ManageSubscriptionModal.styles";

const ManageSubscriptionModal = ({ isOpen, onClose }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useScrollLock(shouldRender);

  // Kontrola renderovanja i animacije
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      setIsAnimating(false); // Početno stanje bez animacije
      // Kratka pauza da se modal renderuje pre animacije
      const timer = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsAnimating(true);
        });
      });
      return () => cancelAnimationFrame(timer);
    } else if (shouldRender) {
      setIsAnimating(false);
      // Čeka da se animacija završi pre uklanjanja iz DOM-a
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // 300ms koliko traje animacija

      return () => clearTimeout(timer);
    }
  }, [isOpen, shouldRender]);

  if (!shouldRender) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick} $isAnimating={isAnimating}>
      <ModalContainer $isAnimating={isAnimating}>
        <ModalContent>
          <ModalText>
            <Row>
              <ModalTitle>Subscription Management</ModalTitle>
              <CloseButton onClick={onClose}>
                <FaTimes />
              </CloseButton>
            </Row>
            Current subscriptions purchased through Telegram Stars.
            <ModalTextBlue> will not automatically </ModalTextBlue>
            renew next month, so there's no need to cancel them manually. They
            will simply expire at the end of their billing period.
          </ModalText>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ManageSubscriptionModal;
